import { render } from "./OpenApiDebugView.vue?vue&type=template&id=bcfa83b2&scoped=true"
import script from "./OpenApiDebugView.vue?vue&type=script&lang=js"
export * from "./OpenApiDebugView.vue?vue&type=script&lang=js"

import "./OpenApiDebugView.vue?vue&type=style&index=0&id=bcfa83b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcfa83b2"]])

export default __exports__